export type PlatformKey =
  | "instagram"
  | "facebook"
  | "twitter"
  | "tiktok"
  | "whatsapp"
  | "google"
  | null

const URL_PATTERNS: Array<{ pattern: RegExp; platform: PlatformKey }> = [
  { pattern: /instagram\.com/i, platform: "instagram" },
  { pattern: /facebook\.com/i, platform: "facebook" },
  { pattern: /(?:x\.com|twitter\.com)/i, platform: "twitter" },
  { pattern: /tiktok\.com/i, platform: "tiktok" },
  { pattern: /wa\.me/i, platform: "whatsapp" },
  { pattern: /google\.com\/maps/i, platform: "google" },
]

const LABEL_PATTERNS: Array<{ pattern: RegExp; platform: PlatformKey }> = [
  { pattern: /instagram/i, platform: "instagram" },
  { pattern: /facebook/i, platform: "facebook" },
  { pattern: /(?:twitter|^x$)/i, platform: "twitter" },
  { pattern: /tiktok/i, platform: "tiktok" },
  { pattern: /whatsapp/i, platform: "whatsapp" },
  { pattern: /google/i, platform: "google" },
]

export function detectPlatform(url: string, label?: string): PlatformKey {
  for (const { pattern, platform } of URL_PATTERNS) {
    if (pattern.test(url)) return platform
  }
  if (label) {
    for (const { pattern, platform } of LABEL_PATTERNS) {
      if (pattern.test(label)) return platform
    }
  }
  return null
}

const PLATFORM_LABELS: Record<Exclude<PlatformKey, null>, string> = {
  instagram: "Instagram",
  facebook: "Facebook",
  twitter: "Twitter",
  tiktok: "TikTok",
  whatsapp: "WhatsApp",
  google: "Google Maps",
}

// Suggests a human-readable label for a pasted link URL (e.g. an
// instagram.com URL → "Instagram"). Returns null for unrecognized hosts so
// callers can leave the label untouched.
export function detectLinkLabel(url: string): string | null {
  const platform = detectPlatform(url)
  return platform ? PLATFORM_LABELS[platform] : null
}

// Drops tracking junk from Instagram URLs: query, fragment and trailing slash.
// Anything else (or an unparseable string) is returned unchanged.
export function cleanInstagramUrl(url: string): string {
  try {
    const u = new URL(url.trim())
    if (!/(^|\.)instagram\.com$/i.test(u.hostname)) return url
    return `${u.origin}${u.pathname.replace(/\/+$/, "")}`
  } catch {
    return url
  }
}
